import { render, staticRenderFns } from "./historyCurve.vue?vue&type=template&id=4145a740&scoped=true&"
import script from "./historyCurve.vue?vue&type=script&lang=js&"
export * from "./historyCurve.vue?vue&type=script&lang=js&"
import style0 from "./historyCurve.vue?vue&type=style&index=0&id=4145a740&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145a740",
  null
  
)

export default component.exports